import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import router from "./Routes/Routes.jsx";
import { AuthProvider } from "./context/AuthProvider";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV || "development",
});


const App = () => (
  <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </Sentry.ErrorBoundary>
);

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
